import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reset-engagement"
export default class extends Controller {
  static targets = ["modal", "confirmationInput", "confirmButton", "form", "codeField"]
  static values = { engagementCode: String }

  connect() {
    // engagementCodeValue is provided via data-reset-engagement-engagement-code-value
  }

  show() {
    this.modalTarget.classList.remove("hidden")
    if (this.hasConfirmationInputTarget) {
      this.confirmationInputTarget.value = ""
      this.confirmationInputTarget.focus()
    }
    this.updateConfirmState(false)
  }

  hide() {
    this.modalTarget.classList.add("hidden")
  }

  preventClose(event) {
    event.stopPropagation()
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.hide()
  }

  validateInput() {
    const ok = this.confirmationInputTarget.value.trim() === this.engagementCodeValue
    this.updateConfirmState(ok)
  }

  updateConfirmState(enabled) {
    if (!this.hasConfirmButtonTarget) return
    this.confirmButtonTarget.disabled = !enabled
    if (enabled) {
      this.confirmButtonTarget.classList.remove("bg-gray-300", "cursor-not-allowed", "text-gray-700")
      this.confirmButtonTarget.classList.add("bg-red-600", "hover:bg-red-700", "focus:ring-red-500", "text-white")
    } else {
      this.confirmButtonTarget.classList.add("bg-gray-300", "cursor-not-allowed", "text-gray-700")
      this.confirmButtonTarget.classList.remove("bg-red-600", "hover:bg-red-700", "focus:ring-red-500", "text-white")
    }
  }

  confirm() {
    const code = this.confirmationInputTarget.value.trim()
    if (code !== this.engagementCodeValue) return
    if (this.hasCodeFieldTarget) this.codeFieldTarget.value = code
    // Optional client analytics
    try { if (window.posthog) { posthog.capture('engagement_hard_reset_clicked', { engagement_code: this.engagementCodeValue }); } } catch(e) {}
    this.formTarget.submit()
    this.hide()
  }
}

